import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const pulse = keyframes`
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const StyledLoader = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
  width: 32,
  height: 32,
  flexShrink: 0,
});

export const StyledDot = styled('span')(({ theme }) => ({
  width: 6,
  height: 6,
  borderRadius: theme.radius.full,
  backgroundColor: theme.colors.brand.solid,
  animation: `${pulse} 1.2s ease-in-out infinite`,
}));
